<template>
    <collapsible-card :title="'Vessels Visited'" v-show="showVessels" ref="cCard">
        <div class="cardContent">
            <div class="clampedTable">
                <table class="staticTable">
                    <thead>
                        <tr>
                            <th scope="col"> Vessel </th>
                            <th scope="col"> Arrival Time </th>
                            <th scope="col"> Departure Time </th>
                            <th scope="col"> Minutes Elapsed </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="obj in vessels" :key="obj.ingress">
                            <td data-label="Vessel"><p class="vesselIdentify"><router-link :to="{name: 'Vessels', params: { mmsi: obj.mmsi }}" class="link">{{obj.mmsi}}</router-link> {{obj.name}}</p></td>
                            <td data-label="Arrival Time" v-if="useUTC">{{obj.ingressUTC}}</td>
                            <td data-label="Arrival Time" v-else>{{obj.ingressLT}}</td>
                            <td data-label="Departure Time" v-if="useUTC && obj.egressUTC">{{obj.egressUTC}}</td>
                            <td data-label="Departure Time" v-else-if="obj.egressLT">{{obj.egressLT}}</td>
                            <td data-label="Departure Time" v-else> — </td>
                            <td data-label="Minutes Elapsed">{{obj.minuteDelta}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </collapsible-card>
</template>

<script>
import { formatDateLT, formatDateUTC } from '../../helpers/Formatting.js';
import CollapsibleCard from '../CollapsibleCard.vue';

export default {
    name: 'platform-vessels',
    components: {
        CollapsibleCard
    },
    data: () => ({
        showVessels: false,
        vessels: [],
        useUTC: false,
    }),
    methods: {
        updateInfo: function(vessels) {
            var globv = this;
            if (vessels && vessels.length > 0) {
                globv.vessels = vessels.map(x => {
                    x['ingressLT'] = formatDateLT(x['ingress']);
                    x['ingressUTC'] = formatDateUTC(x['ingress']);
                    if (x['egress']) {
                        x['egressLT'] = formatDateLT(x['egress']);
                        x['egressUTC'] = formatDateUTC(x['egress']);
                    }
                    if (!x['minuteDelta']) {
                        x['minuteDelta'] = Math.floor((Date.now() - x['ingress']) / 60000);
                    }
                    return x;
                });
            }

            globv.showVessels = globv.vessels.length > 0;
            globv.$refs.cCard.adjustHeight();
        }
    }
}
</script>